<tui-loader class="accordion" [showLoader]="isLoading()" [overlay]="true" textContent="Загрузка...">
  @for (question of questions(); track question.data.id) {
    <button
      class="accordion__item"
      (click)="toggleFaqQuestion(question)"
      tuiButton
      appearance="outline-grayscale"
    >
      <div class="accordion__header">
        <span class="accordion__title">{{ question.data.question }}</span>

        <button
          class="accordion__button"
          [class.accordion__button_active]="question.expanded"
          appearance="secondary-destructive"
          iconStart="plus"
          tuiIconButton
          type="button"
        >
          Показать
        </button>
      </div>

      <tui-expand class="accordion__content" [expanded]="question.expanded">
        <div [innerHTML]="question.data.answer | safe: 'html'"></div>
      </tui-expand>
    </button>
  } @empty {
    <tui-block-status [size]="isMobile() ? 'm' : 'l'">
      <img alt="Ничего не найдено" src="assets/images/not-found.svg" tuiSlot="top" />

      <h4>Ничего не найдено</h4>

      Попробуйте поискать другие вопросы
    </tui-block-status>
  }

  @if (pagesCount() > 1) {
    <tui-pagination
      class="accordion__pagination"
      [index]="currentPage() - 1"
      [length]="pagesCount()"
      (indexChange)="changePage.emit($event)"
      tuiAppearance="ai-pagination"
    />
  }
</tui-loader>
